import { render, staticRenderFns } from "./ContentSearch.vue?vue&type=template&id=54faaeae&scoped=true"
import script from "./ContentSearch.vue?vue&type=script&lang=js"
export * from "./ContentSearch.vue?vue&type=script&lang=js"
import style0 from "./ContentSearch.vue?vue&type=style&index=0&id=54faaeae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54faaeae",
  null
  
)

export default component.exports